module.exports = ".comentarios {\n  max-width: 40%; }\n\n.money {\n  width: 10%; }\n\n.date {\n  width: 10%; }\n\n.name {\n  width: 15%; }\n\n.status {\n  width: 15%; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/limite-adicional-proposal/component/approval-committee-la/approval-committee-la.component.scss
// module id = ./src/app/limite-adicional-proposal/component/approval-committee-la/approval-committee-la.component.scss
// module chunks = main